import { motion } from "framer-motion";
import './price-block.scss';
import blackIcon from './blackIcon.svg';
import whiteIcon from './whiteIcon.svg';
import popularIcon from './popularIcon.svg';

const prices = [
    {
        key: 'starter',
        popular: false,
        title: "Starter",
        subtitle: "Perfect for new investors",
        benefits: [
            "Access to MT4 / MT5 platform",
            "Minimal deposit required",
            "Core trading tools"
        ],
        benefitIcon: whiteIcon,
        price: "300$"
    },
    {
        key: 'pro',
        popular: true,
        title: "Pro",
        subtitle: "Ideal for experienced users",
        benefits: [
            "Expanded platform conditions",
            "Enhanced trading instruments",
            "More flexibility and control"
        ],
        benefitIcon: blackIcon,
        price: "2.000$"
    },
    {
        key: 'vip',
        popular: false,
        title: "VIP",
        subtitle: "Premium user experience",
        benefits: [
            "Priority execution",
            "Exclusive analytics access",
            "Personalized strategy support"
        ],
        benefitIcon: whiteIcon,
        price: "15.000$"
    }
];

const listVariants = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.18 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 36, scale: 0.96 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, ease: "easeOut" } }
};

export default function PriceBlock() {
    return (
        <div className="price-block container" id="price">
            <h2 className="price-block__title title">Choose the Right Plan for You</h2>

            <motion.div
                className="price-block__list"
                variants={listVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                {prices.map((block, idx) => (
                    <motion.div
                        className={`price-block__item${block.popular ? " price-block__item--popular" : ""}`}
                        variants={itemVariants}
                        key={block.key}
                    >
                        {block.popular && (
                            <div className="price-block__popular">
                                <img src={popularIcon} alt="Popular"/>
                                <span>Most popular</span>
                            </div>
                        )}

                        <div className="price-block__item-top">
                            <h4 className="price-block__item-title">{block.title}</h4>
                            <span className="price-block__item-subtitle">{block.subtitle}</span>
                        </div>

                        <div className="price-block__benefits">
                            {block.benefits.map((b, bIdx) => (
                                <div className="price-block__benefit" key={bIdx}>
                                    <img src={block.benefitIcon} alt="Benefit icon"/>
                                    <span>{b}</span>
                                </div>
                            ))}
                        </div>

                        <div className="price-block__item-bottom">
                            <span className="price-block__item-from">From</span>
                            <span className="price-block__item-price">{block.price}</span>
                            <a
                                href={process.env.REACT_APP_LINK}
                                className="price-block__item-button button"
                                tabIndex={0}
                            >Get Started</a>
                        </div>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    );
}
